import Lottie from 'lottie-react';

import lottieCareTeam from '../jsons/care-team.json';

const LottieCareTeam = props => {
  return <Lottie animationData={lottieCareTeam} loop={false} {...props} />;
};

export default LottieCareTeam;
